export default __webpack_public_path__ + "static/media/marker-icon-blue.7ae467ac.svg";